/**
 * Sticky Header Scroll Behavior
 * Hides header on scroll down, shows on scroll up
 */
(function() {
  const header = document.querySelector('.header-sections');
  if (!header) return;

  let lastScrollY = window.scrollY;
  let ticking = false;
  const scrollThreshold = 10; // Minimum scroll distance to trigger
  const topOffset = 100; // Show header when near top

  function updateHeaderState() {
    const currentScrollY = window.scrollY;
    
    // Always show header when at the top
    if (currentScrollY < topOffset) {
      header.classList.remove('down');
      header.classList.add('up');
      lastScrollY = currentScrollY;
      return;
    }

    // Check scroll direction
    if (Math.abs(currentScrollY - lastScrollY) < scrollThreshold) {
      return; // Not enough scroll movement
    }

    if (currentScrollY > lastScrollY) {
      // Scrolling down
      header.classList.remove('up');
      header.classList.add('down');
    } else {
      // Scrolling up
      header.classList.remove('down');
      header.classList.add('up');
    }

    lastScrollY = currentScrollY;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateHeaderState();
        ticking = false;
      });
      ticking = true;
    }
  }

  // Initialize - show header on load
  header.classList.add('up');

  // Listen for scroll events
  window.addEventListener('scroll', onScroll, { passive: true });
})();
